export default {
  current(state) {
    return state.item;
  },
};
